import Vue from 'vue';
import { createStore } from 'vuex'
import ticket from '@/modules/ticket/store';

export default createStore({
    modules: {
        ticket,
    },
    state: {
        me: {},
        authenticated: false,
    },
    getters: {
        me: (state) => state.me,
        authenticated: (state) => state.authenticated,
    },
    mutations: {
        updateMe(state, me) {
            state.me = me;
        },
        login(state, me) {
            state.me = me;
            state.authenticated = true;
        },
        logout(state) {
            state.me = {};
            state.authenticated = false;
        },
    },
    actions: {
    },
});
